export default __webpack_public_path__ + "resources/icons/d430-a182.webp";